/**
 * Social Share Buttons
 */
export default () => {

  const $stat = $('.stat');

  if ($stat.length) {

    $stat.on('click', (e) => {
      e.preventDefault();
      const currPage = window.location.href;
      const tweetMessage = $(e.currentTarget).data('tweet');
      const url = 'https://twitter.com/intent/tweet/?text=' + tweetMessage + '&url=' + currPage;
      windowPopup(url);
    });
  }

};

function windowPopup(url) {
  const top = (screen.height / 3) - 150;
  const left = (screen.width / 2) - 250;

  // Calculate the position of the popup so it's centered on the screen.
  window.open(
    url,
    '',
    'menubar=no,toolbar=no,resizable=yes,scrollbars=yes,width=500,height=300,top=' + top + ',left=' + left
  );
}
